import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { useRecoilState, useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import { selectedCategoryAtom } from "../../recoil";
import { getCategory } from "../../apis/api/Category/getCategory";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export default function CategorySelectForm({ setGroupSelectFormVisible }) {
  const accessToken = useRecoilValue(accessTokenAtom);
  const [checkItems, setCheckItems] = useRecoilState(selectedCategoryAtom);
  const [activeTab, setActiveTab] = useState(null);

  const { data: categoryDataRaw = [] } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategory(accessToken),
    onSuccess: (data) => {
      // Unnamed이 없는 경우 추가
      const hasUnnamed = data.some(el => el.categoryName?.toLowerCase() === "unnamed");
      const extendedData = hasUnnamed
        ? data
        : [...data, { categoryName: "Unnamed" }];

      // 선택된 항목이 없을 경우만 초기 설정
      if (checkItems.length === 0 && extendedData.length > 0) {
        setCheckItems([extendedData[0].categoryName]);
        setActiveTab(extendedData[0].categoryName);
      }
    },
  });


  useEffect(() => {
    // 선택된 카테고리가 있을 경우 activeTab을 설정
    if (checkItems.length > 0) {
      setActiveTab(checkItems[0]);
    }
  }, [checkItems]);

  const handleTabClick = (categoryName) => {
    if (categoryName === activeTab) return;

    setCheckItems([categoryName]);
    setActiveTab(categoryName);
  };

  const { t } = useTranslation();

    console.log("activeTab: " + activeTab);
const sortedCategoryData = categoryDataRaw
  ? (() => {
      const hasUnnamed = categoryDataRaw.some(
        (el) => el.categoryName?.toLowerCase() === "unnamed"
      );
      const dataWithUnnamed = hasUnnamed
        ? categoryDataRaw
        : [...categoryDataRaw, { categoryName: "Unnamed" }];

      return dataWithUnnamed.sort((a, b) => {
        const aName = a.categoryName?.toLowerCase() || "";
        const bName = b.categoryName?.toLowerCase() || "";

        if (aName === "unnamed") return 1;
        if (bName === "unnamed") return -1;
        return aName.localeCompare(bName);
      });
    })()
  : [];

  

  return (
    <Container>
      <TabMenu>
        {sortedCategoryData?.map((category, index) => {
          const isUnnamed = category.categoryName?.toLowerCase() === "unnamed";
          return (
            <Tab
              key={index}
              active={activeTab === category.categoryName}
              onClick={() => handleTabClick(category.categoryName)}
              isUnnamed={isUnnamed}
            >
              {isUnnamed ? "미등록장치" : category.categoryName}
            </Tab>
          );
        })}
      </TabMenu>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 0px 10px 10px;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow for minimalism */
  margin-bottom: 5px;
`;

const TabMenu = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-top: 20px;
  border-bottom: 1px solid #ddd;
  gap: 10px; /* Reduced gap for minimalism */
  padding: 5px 0;
  background-color: #ffffff;
  border-radius: 8px;
`;

const Tab = styled.div`
  padding: 8px 16px; /* Reduced padding for a more compact look */
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  font-size: 14px; /* Smaller font size for a minimalistic feel */
  font-weight: 500;
  color: #444; /* Darker gray for a refined look */
  white-space: nowrap;
  border-radius: 6px 6px 0 0;
  background-color: ${({ isUnnamed }) => (isUnnamed ? "#f0f1f3" : "transparent")};
  margin-left: ${({ isUnnamed }) => (isUnnamed ? "auto" : "0")}; /* Push Unnamed to the far right */

  ${({ active }) =>
    active &&
    `
    font-weight: bold;
    color: #007bff;
    background: linear-gradient(45deg, #ddefff, #f1f7ff);
    border-bottom: 2px solid #007bff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1); /* Soft shadow for depth */
  `}

  &:hover {
    color: #0056b3;
    background-color: ${({ active }) => (!active ? "#f7f9fc" : "#ddefff")};
    transform: translateY(-1px); /* Slight hover lift for interaction feedback */
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08); /* Soft shadow on hover */
  }
`;
